export function len(o: { length?: number } | null | undefined): number {
  if (o && o.length) {
    return o.length;
  }
  return 0;
}

export function throwIf(cond: boolean, msg?: string): void {
  if (cond) {
    throw new Error(msg || "invalid condition");
  }
}

export function fmtSize(n: number): string {
  const a: [number, string][] = [
    [1024 * 1024 * 1024 * 1024, "TB"],
    [1024 * 1024 * 1024, "GB"],
    [1024 * 1024, "MB"],
    [1024, "kB"],
  ];
  for (const el of a) {
    const size = el[0];
    if (n >= size) {
      let s = (n / size).toFixed(2);
      return s.replace(".00", "") + " " + el[1];
    }
  }
  return `${n} B`;
}

export function startTimer(): () => number {
  const timeStart = performance.now();
  return function () {
    return Math.round(performance.now() - timeStart);
  };
}

export function sleep(ms: number): Promise<void> {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

export function fileExt(fileName: string): string {
  const idx = fileName.lastIndexOf(".");
  if (idx === -1) {
    return "";
  }
  return fileName.substring(idx).toLowerCase();
}

// split("a.b.c", ".", 2) => ["a", "b.c"]
// "a.b.c".split(".", 2) => ["a", "b"]
export function splitMax(s: string, sep: string, max: number): string[] {
  throwIf(max === 0);
  const parts = s.split(sep);
  if (parts.length <= max) {
    return parts;
  }
  const restParts = parts.slice(max - 1);
  parts[max - 1] = restParts.join(sep);
  return parts.slice(0, max);
}

export function inflect(s: string, n: number): string {
  if (n == 1) {
    return s;
  }
  return s + "s";
}

export function fnNoOp(): void {}

let uniqueIDCounter = 0;
export function genUniqueID(): number {
  return ++uniqueIDCounter;
}

let sessionStart = performance.now();

export function getSessionDurationInMs(): number {
  return Math.round(performance.now() - sessionStart);
}
